import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	optionsCount: {
		id: 'polaris-lib-observable-values-list.observable-values-list.more-tag.options-count',
		defaultMessage: '{count} more',
		description: 'Number of hidden options',
	},
});
